<template>
  <v-flex>
    <v-card>
      <v-card-title>
        Projects
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="records" :search="search" :rows-per-page-items="[20, 30, 40, 50]">
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.uuid }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td class="text-xs-left">{{ props.item.isPublic }}</td>
          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0" @click.native="editItem(props.item)"><v-icon>edit</v-icon></v-btn>
            <v-btn icon class="mx-0" @click.native="deleteItem(props.item)"><v-icon>delete</v-icon></v-btn>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="warning" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>

    <v-card v-if="edit" class="mt-2 px-3 pt-3">
      <v-layout row>
        <v-flex xs3 style="align-self: center"> Project Name:</v-flex>
        <v-flex xs9><v-text-field color="highlight" height=20 v-model="projectName" label="Name"></v-text-field></v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3 style="align-self: center">Project Description:</v-flex>
        <v-flex xs9><v-text-field color="highlight" height=20 v-model="projectDescription" label="Description"></v-text-field></v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3 style="align-self: center">Is Public</v-flex>
        <v-flex xs9><v-switch height=5 v-model="isPublic" color="accent"></v-switch></v-flex>
      </v-layout>
      <v-layout row v-if="isPublic">
        <v-flex xs3 style="align-self: center">Subscription Plans:</v-flex>
        <v-flex xs9>
          <v-select :items="allPlans" multiple v-model="availablePlans" label="Subscription Plans" item-text="displayName" item-value="id" dense></v-select>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3 style="align-self: center">Project DIY Plan:</v-flex>
        <v-flex xs9>
          <v-select :items="allDiyPlans" v-model="diyPlan" label="DIY Plans" item-text="displayName" item-value="id" dense></v-select>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3 style="align-self: center">Status:</v-flex>
        <v-flex xs9><v-select :items="allStatuses" v-model="status" label="Status" dense></v-select></v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3 style="align-self: center">Categories:</v-flex>
        <v-flex xs9><v-select :items="allCategories" v-model="categories" label="Categories" dense multiple></v-select>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="saveChanges" :disabled="projectChanged" :loading="submitLoading">Submit</v-btn>
        <v-btn @click="pushToSlicer" :disabled="submitLoading" :loading="pushLoading">Push to Slicer</v-btn>
        <v-btn @click="edit = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'
import underscore from 'underscore'

export default {
  data () {
    return {
      loadingState: 'noData',
      records: [],
      search: '',
      headers: [
        { text: 'ID', align: 'left', sortable: true, value: 'id' },
        { text: 'UUID', align: 'left', sortable: true, value: 'uuid' },
        { text: 'Name', align: 'left', sortable: true, value: 'name' },
        { text: 'Description', align: 'left', sortable: true, value: 'description' },
        { text: 'Status', align: 'left', sortable: true, value: 'status' },
        { text: 'Public', align: 'left', sortable: true, value: 'isPublic' },
        { text: '', align: 'left', value: 'actions', sortable: false }
      ],
      edit: false,
      projectName: '',
      projectDescription: '',
      isPublic: false,
      availablePlans: [],
      originalAvailablePlans: [],
      status: 'Pending',
      project: null,
      submitLoading: false,
      pushLoading: false,
      projectOrganization: null,
      categories: [],
      diyPlan: null,
      originalDiyPlan: null
    }
  },
  computed: {
    ...mapGetters({
      getPlanById: 'getPlanById',
      allStatuses: 'getStatuses',
      allPlans: 'getSubscriptionPlans',
      allCategories: 'getProjectCategories',
      allDiyPlans: 'getDiyPlans'
    }),
    projectChanged () {
      return this.projectName === this.project.name && this.projectDescription === this.project.description && this.project.isPublic === this.isPublic && underscore.isEqual(this.originalAvailablePlans, this.availablePlans) && this.status === this.project.status && underscore.isEqual(this.categories, this.project.config.categories) && this.diyPlan === this.originalDiyPlan
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    editItem (item) {
      this.loadingState = true
      this.project = item
      this.projectName = item.name
      this.projectDescription = item.description
      this.isPublic = item.isPublic
      this.status = item.status
      this.availablePlans = []
      this.originalAvailablePlans = []
      this.categories = item.config.categories
      axios.all([this.$store.dispatch('getProjectPlans', {id: item.id}), this.$store.dispatch('getOrganizationsWithAllById', {id: item.createdByOrganizationId})]).then(axios.spread((response, orgResponse) => {
        if (response.data.status === 'SUCCESS' && orgResponse.data.status === 'SUCCESS') {
          var self = this
          response.data.payload.forEach(function (plan) {
            var planObject = self.getPlanById(plan.planId)
            if (planObject.tier !== 0) {
              self.availablePlans.push(planObject.id)
              self.originalAvailablePlans.push(planObject.id)
            }
          })
          this.projectOrganization = orgResponse.data.payload
          var projectPlan = orgResponse.data.payload.organizationProjects.find(item => { return item.projectId === this.project.id })
          if (projectPlan) {
            this.diyPlan = projectPlan.planId
            this.originalDiyPlan = projectPlan.planId
          }
          this.loadingState = false
          this.edit = true
        }
      })).catch((err) => {
        this.loadingState = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    pushToSlicer () {
      this.pushLoading = true
      var project = JSON.parse(JSON.stringify(this.project))
      axios.all([this.$store.dispatch('pushProjectToSlicer', project)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.pushLoading = false
          this.notify({message: 'Project successfully pushed to slicer.', show: true})
        } else {
          this.notify({message: 'Something went wrong while pushing to slicer.', show: true})
          this.pushLoading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.pushLoading = false
        console.log(err)
      })
    },
    saveChanges () {
      this.submitLoading = true
      if (this.projectName !== this.project.name || this.projectDescription !== this.project.description || this.project.isPublic !== this.isPublic || this.status !== this.project.status || !underscore.isEqual(this.categories, this.project.config.categories)) {
        this.updateProject()
      } else if (!underscore.isEqual(this.originalAvailablePlans, this.availablePlans)) {
        this.updateProjectPlans()
      } else if (this.diyPlan !== this.originalDiyPlan) {
        this.updateOrganizationProject()
      }
    },
    updateProject () {
      this.submitLoading = true
      var project = JSON.parse(JSON.stringify(this.project))
      project.name = this.projectName
      project.description = this.projectDescription
      project.isPublic = this.isPublic
      project.status = this.status
      project.config.categories = this.categories
      axios.all([this.$store.dispatch('updateProject', project)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (!underscore.isEqual(this.originalAvailablePlans, this.availablePlans)) {
            this.updateProjectPlans()
          } else if (this.status !== this.project.status && this.status === 'Active' && this.project.isDiyBillable === true) {
            this.activateProjectStripe()
          } else if (this.diyPlan !== this.originalDiyPlan) {
            this.updateOrganizationProject()
          } else {
            this.edit = false
            this.submitLoading = false
            this.getData()
            this.notify({message: 'Project successfully updated.', show: true})
          }
        } else {
          this.notify({message: 'Something went wrong.', show: true})
          this.submitLoading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.submitLoading = false
        console.log(err)
      })
    },
    updateProjectPlans () {
      this.submitLoading = true
      var plansObject = {
        projectId: this.project.id,
        planIds: this.availablePlans
      }
      axios.all([this.$store.dispatch('deleteAllProjectPlans', {id: this.project.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          axios.all([this.$store.dispatch('addProjectPlans', plansObject)]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              if (this.diyPlan !== this.originalDiyPlan) {
                this.updateOrganizationProject()
              } else if (this.status !== this.project.status && this.status === 'Active' && this.project.isDiyBillable === true) {
                this.activateProjectStripe()
              } else {
                this.submitLoading = false
                this.edit = false
                this.getData()
                this.notify({message: 'Project successfully updated.', show: true})
              }
            } else {
              this.notify({message: 'Something went wrong.', show: true})
              this.submitLoading = false
            }
          })).catch((err) => {
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            this.submitLoading = false
            console.log(err)
          })
        } else {
          this.notify({message: 'Something went wrong.', show: true})
          this.submitLoading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.submitLoading = false
        console.log(err)
      })
    },
    updateOrganizationProject () {
      this.submitLoading = true
      var planObject = JSON.parse(JSON.stringify(this.projectOrganization.organizationProjects.find(item => { return item.projectId === this.project.id })))
      planObject.planId = this.diyPlan
      axios.all([this.$store.dispatch('updateOrganizationProject', planObject)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (this.status !== this.project.status && this.status === 'Active' && this.project.isDiyBillable === true) {
            this.activateProjectStripe()
          } else {
            this.submitLoading = false
            this.edit = false
            this.getData()
            this.notify({message: 'Project successfully updated.', show: true})
          }
        } else {
          this.notify({message: 'Something went wrong.', show: true})
          this.submitLoading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.submitLoading = false
        console.log(err)
      })
    },
    activateProjectStripe () {
      this.submitLoading = true
      let plan = this.getPlanById(this.projectOrganization.organizationProjects.find(item => { return item.projectId === this.project.id }).planId)
      let organizationUuid = this.projectOrganization.uuid
      let userOrganization = this.projectOrganization
      let projectUuid = this.project.uuid
      if (plan.tier !== 0) {
        axios.all([this.$store.dispatch('stripe/retrieveCustomer', {organizationUuid: organizationUuid})]).then(axios.spread((retrieveCustomerResponse) => {
          if (retrieveCustomerResponse.data.status === 'SUCCESS') {
            if (retrieveCustomerResponse.data.payload === undefined || retrieveCustomerResponse.data.payload.sources === null) {
              this.submitLoading = false
              this.notify({message: 'No payment information provided by creating organization', show: true})
              this.deactivateProject()
              return 'error'
            } else {
              let interval = ''
              let intervalCount = 1
              if (plan.period === 'MONTHLY') {
                interval = 'month'
              } else if (plan.period === 'QUARTERLY') {
                interval = 'month'
                intervalCount = 3
              } else if (plan.period === 'YEARLY') {
                interval = 'year'
              }
              let payload = {
                name: this.project.name,
                description: this.project.description,
                monthlyFee: plan.fixedFee,
                period: plan.period,
                interval: interval,
                intervalCount: intervalCount,
                subscriptionId: userOrganization.stripeSubConfig !== null && plan.period in userOrganization.stripeSubConfig ? userOrganization.stripeSubConfig[plan.period] : null,
                organizationUuid: organizationUuid,
                projectUuid: projectUuid,
                planUuid: plan.uuid,
                trialPeriodDays: 0,
                type: 'DIY'
              }
              axios.all([this.$store.dispatch('stripe/subscribe', payload)]).then(axios.spread((subscriptionResponse) => {
                if (subscriptionResponse.data.status === 'SUCCESS') {
                  this.activateProject()
                } else {
                  this.submitLoading = false
                  this.notify({message: 'Could not subscribe organization to project.', show: true})
                  this.deactivateProject()
                  return 'error'
                }
              })).catch((err) => {
                this.submitLoading = false
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                console.log(err)
                return 'error'
              })
            }
          }
        })).catch((err) => {
          this.submitLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
          return 'error'
        })
      } else {
        this.activateProject()
      }
    },
    activateProject () {
      this.submitLoading = true
      var projectActivation = {
        requestedProjectId: this.project.id,
        requestingUserId: this.project.createdByUserId,
        requestingOrganizationId: this.project.createdByOrganizationId
      }
      axios.all([this.$store.dispatch('activateProject', projectActivation)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.submitLoading = false
          this.getData()
          this.notify({message: 'Project successfully updated.', show: true})
          this.edit = false
        } else {
          this.notify({message: 'Something went wrong.', show: true})
          this.submitLoading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.submitLoading = false
        console.log(err)
      })
    },
    deactivateProject () {
      this.submitLoading = true
      var project = JSON.parse(JSON.stringify(this.project))
      project.status = 'Pending External Approval'
      axios.all([this.$store.dispatch('updateProject', project)]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
        } else {
          this.notify({message: 'Something went wrong.', show: true})
          this.submitLoading = false
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.submitLoading = false
        console.log(err)
      })
    },
    deleteItem (item) {
      this.edit = false
      this.$vuetifyConfirmDialog.open('Please Confirm', 'Are you sure you want to delete this item?', 'Cancel', 'Delete').then(state => {
        if (state) {
          this.loadingState = 'loading'
          axios.all([this.$store.dispatch('admin/deleteProject', item)]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              this.records.splice(this.records.indexOf(item), 1)
              this.loadingState = 'complete'
            } else {
              this.loadingState = 'error'
            }
          })).catch((err) => {
            this.loadingState = 'error'
            console.log(err)
          })
        }
      })
    },
    getData: function () {
      this.loadingState = 'loading'
      axios.all([this.$store.dispatch('admin/getProjectsWithAll')]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (response.data.payload && response.data.payload.length > 0) {
            this.records = response.data.payload
            this.loadingState = 'complete'
          } else {
            this.records = []
            this.loadingState = 'noData'
          }
        } else {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          this.loadingState = 'error'
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        this.loadingState = 'error'
        console.log(err)
      })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/ProjectsTable.vue